<template>
	<ProgressSpinner v-if="!firmware"/>
	<Container class="pt-6" v-if="firmware">

		<div
				v-if="firmware.release_notes?.length === 0 || firmware.testing_documents?.length === 0 || firmware.regulations?.length === 0">
			<Alert>
				{{ $t('pages.admin.firmware.firmware.firmware.firmware_view.this_firmware_is_missing_some_required_documents_or_information') }}

				<template #list>
					<li v-if="firmware.release_notes?.length === 0">
            {{ $t('pages.admin.firmware.firmware.firmware.firmware_view.release_notes') }}
          </li>
					<li v-if="firmware.testing_documents?.length === 0">
            {{ $t('pages.admin.firmware.firmware.firmware.firmware_view.testing_documents') }}
          </li>
					<li v-if="firmware.regulations?.length === 0">
            {{ $t('pages.admin.firmware.firmware.firmware.firmware_view.regulations') }}
          </li>
				</template>
			</Alert>
		</div>

		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ firmware.version_number ?? $route.params.firmware }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="onSave"
				@on-delete="$emit('on-delete')"
				@refresh-firmware="refreshFirmware"
				:firmware="firmware"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useFirmwaresStore } from "@/stores/firmwares.js";
import Container from "@/Components/Container.vue";
import { IconAlertTriangleFilled } from '@tabler/icons-vue';
import Alert from "@/Components/Alert.vue";


export default {
	name: "FirmwareView",
	components: {Alert, Container, TabLayout, PageHeading, IconAlertTriangleFilled},
	data() {
		return {
			firmware: undefined,
		}
	},
	methods: {
		async refreshFirmware() {
			this.firmware = await this.firmwaresStore.showFirmware(this.$route.params.firmware, {
				fields: {
					firmwares: [
						'id',
						'version_number',
						'name',
						'size_bytes',
						'mime_type',
					]
				},
				include: [
					'releaseNotes',
					'testingDocuments',
					'regulations',
				],
			});
		},
		async onSave() {
			this.$emit('on-save');
		},
	},
	watch: {
		'$route.params.firmware': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.firmware === 'NEW') {
						this.firmware = await this.firmwaresStore.createFirmware();
					} else {
						await this.refreshFirmware();
					}
				} else {
					this.firmware = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useFirmwaresStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.firmware.firmware.firmware.firmware_view.summary'),
					current: this.$route.name === 'admin.firmware.firmware',
					to: {name: 'admin.firmware.firmware', params: this.$route.params}
				},
				{
					label: this.$t('pages.admin.firmware.firmware.firmware.firmware_view.release_notes'),
					current: this.$route.name === 'admin.firmware.firmware.release-notes',
					to: {name: 'admin.firmware.firmware.release-notes', params: this.$route.params}
				},
				{
					label: this.$t('pages.admin.firmware.firmware.firmware.firmware_view.testing_documents'),
					current: this.$route.name === 'admin.firmware.firmware.testing-documents',
					to: {name: 'admin.firmware.firmware.testing-documents', params: this.$route.params}
				},
				{
					label: this.$t('pages.admin.firmware.firmware.firmware.firmware_view.regulations_x', { count: this.firmware.regulations?.length }),
					current: this.$route.name === 'admin.firmware.firmware.regulations',
					to: {name: 'admin.firmware.firmware.regulations', params: this.$route.params},
					permission: 'read:regulations',
					hide: true || !this.firmware.id
				},
				{
					label: this.$t('pages.admin.firmware.firmware.firmware.firmware_view.history'),
					current: this.$route.name === 'admin.firmware.firmware.history',
					to: {name: 'admin.firmware.firmware.history', params: this.$route.params}
				},
			].filter(t => (t.permission === undefined || this.$auth.hasPermission(t.permission)) && !t.hide)
		}
	},
}
</script>
